import React from "react";
import styled from "styled-components";

import imagemFundo from "../../images/imagemfundo.png";

import proximo from "../../images/proximo.png";
import P2Imagem from "../../images/P2.png";
import maisCotas from "../../images/sinalMaisIcon.png";
import incluirCota from "../../images/incluirCota.png";
import Globais from "../../css/Globais";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  opacity: 80%;
  button {
    border: none;

    background: transparent;
    &:hover {
      cursor: pointer;
    }
  }
`;
const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 20%;

  @media (min-width: 500px) {
    width: 15%;
  }

  @media (min-width: 600px) {
    width: 10%;
  }
  @media (min-width: 700px) {
    width: 8%;
  }
  @media (min-width: 900px) {
    width: 6%;
  }
`;
const ImagemMaior = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;

  @media (min-width: 900px) {
    width: 90%;
  }
`;
const ImagemMenor = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  justify-self: center;
  @media (min-width: 500px) {
    width: 90%;
  }

  @media (min-width: 600px) {
    width: 80%;
  }
  @media (min-width: 700px) {
    width: 70%;
  }
  @media (min-width: 900px) {
    width: 50%;
  }
  @media (min-width: 1100px) {
    width: 40%;
  }
  @media (min-width: 1300px) {
    width: 30%;
  }
`;
const ImagemProsseguir = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 13%;
  justify-self: center;
  @media (min-width: 500px) {
    width: 10%;
  }
  @media (min-width: 700px) {
    width: 7%;
  }
  @media (min-width: 900px) {
    width: 5%;
  }
`;
const ContainerTermo = styled.div`
  width: 100%;
  height: 100%;
  max-width: 80rem;
  min-width: 15rem;
  min-height: 30rem;
  justify-self: flex-start;

  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color: #fff;
  border-radius: 30px;
  position: absolute;
  z-index: 0;
  display: grid;
  grid-template: 10% 90%/ 100%;
  justify-content: center;
  aligm-itens: center;
`;

const TextWrapper = styled.div`
  display: flex;

  justify-content: flex-start;

  margin-left: 2rem;
  margin-right: 2rem;
  overflow: auto;

  flex-direction: column;
  @media (min-width: 450px) {
    margin-left: 5rem;
    margin-right: 5rem;
  }
  #text {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  #button {
    a {
      width: 100%;

      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  #voltar {
    diplay: grid;

    grid-template: 50% 50% / 100%;
    align-items: center;
    justify-content: center;
  }
`;

const ContainerTitulo = styled.div`
  width: 100%;

  height: 100%;
  display: flex;
  justify-content: center;
`;

const Titulo = styled.h1`
  text-align: center;
  align-self: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.2rem;
  width: 80%;
  margin-top: 3rem;
  margin-bottom: 3rem;
  @media (min-width: 400px) {
    font-size: 1.5rem;
  }
  @media (min-width: 700px) {
    font-size: 1.8rem;
  }
`;

const H3 = styled.h3`
  text-align: left;

  color: ${Globais.CorAzulBackGround};
  font-size: 1rem;

  @media (min-width: 400px) {
    font-size: 1.2rem;
  }
`;

export default function ViewPrimeiraVezCadastroCotas() {
  return (
    <Container>
      <Imagem src={imagemFundo} alt="" />
      <ContainerTermo>
        <ContainerTitulo>
          <Titulo>COMO CADASTRAR UMA COTA?</Titulo>
        </ContainerTitulo>

        <TextWrapper>
          <H3>
            <br />
            <p> 1º Clique no botão "+" que fica no canto superior direito: </p>
            <Imagem src={maisCotas}></Imagem>
            <p>
              {" "}
              2º Selecione o empreendimento, o apartamento e o número da cota:
            </p>
            <ImagemMaior src={incluirCota}></ImagemMaior>
            <br />
            <p> 3º Clique em incluir.</p>
            <br />
            <p>Pronto! Cota cadastrada com sucesso!</p>
            <br />
            <p>
              Obs:
              <p>
                {" "}
                1 - Identifique o apartamento pelo nome e pela capacidade.{" "}
              </p>
              <p>
                2 - Caso não encontre o empreendimento ou o apartamento clique
                no botão para incluir manualmente.
              </p>
              <ImagemMenor src={P2Imagem}></ImagemMenor>
            </p>
            <div id="voltar">
              <div id="text">
                <p>Prosseguir com cadastro da cota</p>
              </div>
              <div id="button">
                <a href="/cadastrocotas">
                  <ImagemProsseguir src={proximo} />
                </a>
              </div>
            </div>
          </H3>
        </TextWrapper>
      </ContainerTermo>
    </Container>
  );
}
